import { morph } from '@theme/morph';
import { ProductSelectEvent, StandardEvents } from '@shopify/events';

class ProductBundleDescription extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.updateBundleDescription);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.updateBundleDescription);
  }

  /** @param {ProductSelectEvent} event */
  updateBundleDescription = (event) => {
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newBundleDescription = detail.html.querySelector('product-bundle-description');
        if (!newBundleDescription) return;

        this.dataset.hasBundle = newBundleDescription.dataset.hasBundle || 'false';
        this.dataset.metafieldSource = newBundleDescription.dataset.metafieldSource || 'product';
        this.style.display = this.dataset.hasBundle === 'true' ? 'block' : 'none';
        morph(this, newBundleDescription, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[product-bundle-description] Product selection failed:', error);
      });
  };
}

if (!customElements.get('product-bundle-description')) {
  customElements.define('product-bundle-description', ProductBundleDescription);
}
